import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appOnlyNumber]'
})
export class OnlyNumberDirective {
    @HostListener('keydown', ['$event'])
    onKeyDown(evt: KeyboardEvent) {
        const nav = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'];
        if (nav.includes(evt.key)) return;
        if (!/^\d$/.test(evt.key)) {
            evt.preventDefault();
        }
    }
}